<template>
  <div class="reports-index">
    <el-form class="search-filter">
      <div class="filter-worker">
        <date-picker
          lang="ru"
          :editable="false"
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="filter.datetimeRange"
          @change="changeFiled"
        ></date-picker>
      </div>
      <div class="filter-worker">
        <filter-select
          v-if="userRole === 'admin'"
          v-model="filter.users"
          label="Выберите пользователя"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.users"
        />
        <strong style="margin-top: 10px;display: block;" v-if="userRole && userRole !== 'admin'">{{filter.users.label}}</strong>
      </div>
      <div class="filter-worker">
        <filter-select
          v-model="filter.object"
          label="Выберите обьект"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.objects"
        />
      </div>
      <div class="filter-worker">
        <filter-select
          v-model="filter.typeJob"
          label="Выберите вид работ"
          hideLabel
          @input="changeFiled"
          :options="filterCollection.typeJobs"
        />
      </div>
    </el-form>
    <div v-if="false" class="chart-div">
      <line-chart :chart-data="dataCollection" :options="chartOptions"></line-chart>
    </div>
    <h1 v-if="empty">По выбраному фильтру ничего не найдено</h1>
    <dl class="info-block" v-if="!empty">

      <el-table
        :data="count"
        :show-header="false"
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="Name"
        >
        </el-table-column>
        <el-table-column
          prop="count"
          label="Count"
        >
        </el-table-column>
      </el-table>
    </dl>
  </div>
</template>


<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';
import getItemsForUser from '../../../utils/getItemsForUser'
import LineChart from './LineChart.js';
import 'vue2-datepicker/index.css';
import FilterSelect from '../../../components/FilterSelect';
import {formatEndDate, formatStartDate} from "../../../utils/date";

const oneDay = 24 * 60 * 60 * 1000;
export default {
  name: 'Index',
  components: {DatePicker, LineChart, FilterSelect},
  data() {
    return {
      empty: false,
      shortcuts: [
        {
          text: 'День',
          onClick() {
            const dateNow = new Date();
            const dateLast = new Date(dateNow.getTime() - 24 * 60 * 60 * 1000);
            return [dateLast, dateNow];
          },
        },
        {
          text: 'Неделя',
          onClick() {
            const dateNow = new Date();
            const dateLast = new Date(dateNow.getTime() - 7 * 24 * 60 * 60 * 1000);
            return [dateLast, dateNow];
          },
        },
        {
          text: 'Месяц',
          onClick() {
            const dateNow = new Date();
            const dateLast = new Date(dateNow.getTime() - 31 * 24 * 60 * 60 * 1000);
            return [dateLast, dateNow];
          },
        },
        {
          text: 'За все время',
          onClick() {
            return [];
          },
        },
      ],
      filter: {
        users: null,
        jobs: [],
        object: null,
        typeJob: null,
        datetimeRange: new Date(Date.now()),
      },
      count: [],
      chartOptions: {
        responsive: true,
        scales: {
          xAxes: [{
            ticks: {
              min: null,
              max: null,
            },
          }],
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true,
              max: 10,
            },
          }],
        },
      },
      dataCollection: {
        labels: [],
        datasets: [],
      },
      filterCollection: {
        users: [],
        jobs: [],
        objects: [],
        typeJobs: [],
      },
      colorMap: {},
      userRole: null
    };
  },

  mounted() {
    if (this.$store.state.project.disableDate) {
      this.filter.datetimeRange = new Date('2021-08-24');
    }

    const defaultQuery = firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('reports')
      .where('type', '==', 'TECH');

    Promise.all([
      this.fetchUsers(defaultQuery),
      this.fetchJobs(defaultQuery),
      this.fetchObjects(defaultQuery),
      this.fetchTypeJobs(defaultQuery)
    ]).then(() => this.changeFiled())


  },

  watch: {},

  methods: {
    fetchTypeJobs(defaultQuery) {
      const typeJobsArray = [];
      return defaultQuery
        .get().then((response) => {
        let hasEmpty = false;
        response.forEach((sub) => {
          const data = sub.data();
          if (!hasEmpty) {
            hasEmpty = data.work_type.length === 0;
          }
          typeJobsArray.push(...data.work_type);
        });
        const setJobsType = typeJobsArray
          .filter(item => {
            const result = !!item.label;
            if (!result && !hasEmpty) {
              hasEmpty = !result;
            }
            return !!item.label;
          })
          .reduce((acum, item) => (acum[item.label] = item, acum), {});
        const objectForFilter = Object.entries(setJobsType).map(([key, item]) => {
          return {
            label: key,
            value: JSON.stringify(item),
          };
        });

        if (hasEmpty) {
          objectForFilter.unshift({
            value: 'empty',
            label: 'Нет вида работ',
          });
        }

        objectForFilter.unshift({
          value: null,
          label: 'Все работы',
        });

        this.filterCollection.typeJobs = objectForFilter;
      });
    },
    fetchObjects(defaultQuery) {
      const loadObjectByParentId = (id, result = []) => {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('objects')
          .doc(id)
          .get().then(r => {
            const data = r.data()
            if (!data) {
              return result
            }
            const {parentId, name, index} = data
            result.push({id: id, name: name, index: index})
            if (!parentId) {
              return result
            }
            return loadObjectByParentId(parentId, result)

          })
      }

      const objectsArray = [];
      return defaultQuery
        .get().then((response) => {
        response.forEach((sub) => {
          const data = sub.data();
          if(data.object.id) {
            objectsArray.push(data.object);
          }
        });
        const queryArrayPromise = objectsArray.map(i => {
          if(i.id) {
            return firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('objects')
              .doc(i.id)
              .get().then(r => loadObjectByParentId(i.id, []))
          }
        })

        return Promise.all(queryArrayPromise)
          .then(objectsArrayFromDirectory => {
            return objectsArrayFromDirectory.filter(i => i.length > 0).map((item) => {
              const reverseItem = item.reverse()
              return {
                id: reverseItem[reverseItem.length - 1].id,
                name: reverseItem.map(item => item.name).join(' > '),
                index: reverseItem[reverseItem.length - 1].index
              }
            })
          })
          .then((r) => r.reduce((acum, item) =>(acum[item.id] = item, acum), {}))
      }).then((objectMap) => {
        const hasEmptyObject = objectsArray.some(i => i === '');

        const acumObject = {
          [null]: {
            value: null,
            label: 'Все обьекты',
          },
        };
        if (hasEmptyObject) {
          acumObject['empty'] = {
            value: 'empty',
            label: 'Нет объекта',
          };
        }

        this.filterCollection.objects = Object.values(
          objectsArray.filter(item => !!item)
            .sort((a, b) => objectMap[a.id].index > objectMap[b.id].index && 1 || -1)
            .reduce((acum, item) => (acum[item.id] = {value: item.id, label: objectMap[item.id].name}, acum), acumObject),
        );
      }).then(() => {
        return getItemsForUser(
        firebase.auth().currentUser.uid,
          this.$store.state.project.id
        )
      }).then((accessData) => {
        if (accessData.user.role === 'admin' || accessData.company.usePermission !== true) {
          return;
        }

        this.filterCollection.objects = this.filterCollection.objects.filter((item) => {
        return item.value === null || accessData.saveObject[item.value];
        })
      });
    },
    fetchJobs(defaultQuery) {
      const jobsArray = [];
      return defaultQuery
        .get().then((response) => {
        response.forEach((sub) => {
          const data = sub.data();
          jobsArray.push(...Object.values(data.jobs));
        });

        this.colorMap = Object.values(jobsArray.reduce((acum, item) => {
          return item.reduce((a, i) => (a[i.job.id] = i.job, a), acum);
        }, {})).reduce((acum, item) => {
          acum[item.name] = this.getRandomColor();
          return acum;
        }, {});
        this.filterCollection.jobs = Object.values(jobsArray.reduce((acum, item) => {
          return item.reduce((a, i) => (a[i.job.id] = i.job, a), acum);
        }, {})).map((i) => ({
          uid: i.id,
          name: i.name,
        }));
      });
    },
    fetchUsers(defaultQuery) {

      const usersArray = [];
      return defaultQuery
        .get().then((response) => {
        response.forEach((sub) => {

          const data = sub.data();
          usersArray.push(data.user);
        });
        const users = Object.values(usersArray.reduce((acum, item) => (acum[item.uid] = item, acum), {}));
        const resultList = users.reduce((acum, i) => {
          const name = i.company || i.name;
          acum[name] = acum[name] || [];
          acum[name].push(i.uid);
          return acum;
        }, {});
        const resultUser = Object.entries(resultList).map(([key, val]) => ({
          uid: val.join(','),
          company: key,
        }));
        resultUser.unshift({
          uid: null,
          company: 'Все исполнители',
        });

        this.filterCollection.users = resultUser.map((item) => ({
          value: item.uid,
          label: item.company || item.email,
        }));
      }).then(() => {
        return getItemsForUser(
          firebase.auth().currentUser.uid,
          this.$store.state.project.id
        )
      })
      .then(({user}) => {
        const {company, role} = user;
        this.userRole = 'admin';
        if (role !== 'admin') {
          // this.userRole = role;
          this.filterCollection.users = this.filterCollection.users.filter(value => value.label === company)
          this.filter.users = this.filterCollection.users[0]
          this.filter.users = this.filterCollection.users[0] || {label: company, value: user['uid']}
        }

      });
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    getRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    changeFiled() {
      let query = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .where('type', '==', 'TECH');
      if (this.filter.datetimeRange) {
        query = query.where('dateunix', '>', formatStartDate(this.filter.datetimeRange));
        query = query.where('dateunix', '<', formatEndDate(this.filter.datetimeRange));
      }

      if (this.filter.users && this.filter.users.value) {
        query = query.where('user.uid', 'in', this.filter.users.value.split(','));
      }

      if (this.filter.jobs.length > 0) {
        const mtp = this.filter.jobs.map(i => {
          return {['job.id']: i};
        });
        query = query.where('jobs', 'array-contains', [{value: 5}]);
      }

      if (this.filter.object && this.filter.object.value) {
        const fieldPath = this.filter.object.value === 'empty' ? 'object' : 'object.id';
        const filter = this.filter.object.value === 'empty' ? '' : this.filter.object.value;
        query = query.where(fieldPath, '==', filter);
      }

      // if (this.filter.typeJob) {
      //   query = query.where('work_type', 'array-contains', JSON.parse(this.filter.typeJob))
      // }
      query.get().then((response) => {
        const result = [];
        response.forEach((sub) => {
          result.push(sub.data());
        });
        return result;

      })
        .then((response) => {
          if (response.length === 0) {
            this.empty = true;
            return;
          }
          this.empty = false;
          const aggregateCount = response.reduce((acum, data) => {
            return Object.entries(data.jobs).reduce((acumInnerFirst, [key, item]) => {
              return data.jobs[key]
                .filter(i => {
                  if (!this.filter.typeJob || !this.filter.typeJob.value) {
                    return true;
                  }
                  if (this.filter.typeJob.value === 'empty') {
                    return i.job.work_type_name === '' || i.job.work_type_name === null;
                  } else {
                    return i.job.work_type_name === JSON.parse(this.filter.typeJob.value).label;
                  }

                })
                .reduce((acumInnerSecond, i) => {
                  acumInnerSecond[i.job.name] = acumInnerSecond[i.job.name] || [];
                  acumInnerSecond[i.job.name].push({
                    x: new Date(data.datetime).toISOString(),
                    y: parseInt(i.value, 10),
                  });
                  return acumInnerSecond;
                }, acumInnerFirst);
            }, acum);
          }, {});
          const xSet = new Set();
          const ySet = new Set();
          const datasets = Object.entries(aggregateCount)
            .map(([key, val]) => {
              val.forEach(i => {
                xSet.add(new Date(i.x).getTime());
                ySet.add(i.y);
              });
              return {
                label: key,
                backgroundColor: this.colorMap[key],
                data: val,
              };
            });
          let allCount = 0;
          this.count = Object.entries(aggregateCount).map(([name, item]) => {
            const count = item.reduce((acum, item) => (acum += item.y, acum), 0);
            allCount += count;
            return {
              name,
              count,
            };
          });
          this.count.unshift({
            name: 'Всего',
            count: allCount,
          });

          const labels = [...xSet].sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
          const timeStampArray = labels.map(i => new Date(i).getTime());
          this.chartOptions.scales.xAxes[0].ticks.min = Math.min.apply(Math, timeStampArray);
          this.chartOptions.scales.xAxes[0].ticks.max = Math.max.apply(Math, timeStampArray);
          this.chartOptions.scales.yAxes[0].ticks.max = Math.max.apply(Math, [...ySet]) + 5;

          // this.dataCollection = {
          //   labels: [...new Set(labels.map(i => dayjs(i.substring(0, i.indexOf('+'))).format('DD/MM/YYYY')))],
          //   datasets,
          // };
        });
    },
  },
};
</script>

<style scoped lang="scss">
.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 764px) {
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: 100%;

    .el-select {
      width: 100%;
    }
  }
}

.filter-worker {
  min-width: 200px;
  margin-top: 10px;
  margin-right: 5px;
}

.chart-div {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  div {
    width: 500px !important;
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
  }
}

.info-block {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

dl {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

dt {
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  text-align: right;
  box-sizing: border-box;
  padding-right: 10px;
  font-weight: bold;
  margin: 0px;
}

dd {
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10px;
  margin: 0px;
}

.mx-datepicker-range {
  width: 100%;

  .mx-input {
    border: 1px solid #DCDFE6;
    height: 40px;
  }
}

> > > .el-table__body {
  .cell {
    font-weight: 600;
  }
}
@media screen and (min-width: 764px) {
  > > > .filter-worker {
    height: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/ConstructionEngineering.vue